/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { fetchGraphQl } from '@/quote-management/api/';
import { QUOTE_DATA_QUERY } from './graphql/QuoteDataQuery';
import { transformQuote } from '@/quote-management/data/transforms';
import { state } from '@/quote-management/lib/state';
import { events } from '@adobe-commerce/event-bus';

export const getQuoteData = async (quoteId: string) => { 
    if (!state.authenticated) {
        return Promise.reject(new Error('Unauthorized'));
    }

    if (!state.permissions.editQuote) {
        return Promise.reject(new Error('Unauthorized'));
    }

    try {
        const results: any = await fetchGraphQl(QUOTE_DATA_QUERY, {
            variables: {
                quoteId
            }
        });

        const transformedQuote = transformQuote(results?.data?.negotiableQuote);

        if (!transformedQuote) {
            throw new Error('Failed to transform quote data');
        }

        events.emit('quote-management/quote-data', {
            quote: transformedQuote,
            permissions: state.permissions,
        });
        
        return transformedQuote;
    } catch (error) {
        return Promise.reject(error);
    }
}
